const guestEmail = Cookies.get("guest");

if (typeof guestEmail !== "undefined") {
  const decodedEmail = atob(guestEmail); // guest email entered
  // do something with guest email here
} else {
  // if get user cookie doesn't exist
  window.location.href = "/account/login";
}
